// extracted by css-extract-rspack-plugin
export default {"row":"l3Y0a","wrap":"MDUye","nowrap":"CJx3L"};